export const INTERCOM_APP_ID =
    process.env.NODE_ENV === "production" ? "oc3xi4bh" : "tics5hue";
